import { render, staticRenderFns } from "./survey-step-last-leg-angiogram.vue?vue&type=template&id=82fd5f8c"
import script from "./survey-step-last-leg-angiogram.vue?vue&type=script&lang=js"
export * from "./survey-step-last-leg-angiogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports